import React from "react";

export default function AntiCoruption() {
  return <div></div>;
}